import { useTranslation } from 'react-i18next';
import { groupByFor } from '@platform/core/lib/viewSettings';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import type { IViewBoardColumnsProps } from './IViewBoardColumnsProps';

/** «Стовпці дошки» (прототип v4): вибір поля колонок — «Типово · <поле дошки типу>» і поля вибору типу (32px, від 220px). */
export function ViewBoardColumns({ rt, groupBy, onChange }: IViewBoardColumnsProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const label = (key: string) => (key === 'status' ? t('form.status') : strings.field(rt.key, key, rt.fields.find((f) => f.key === key)?.label));
  const choices = rt.fields.filter((f) => f.type === 'select' && f.key !== 'status' && !f.hidden);
  return (
    <div className="lv-vs__field">
      <span className="lv-vs__caption">{t('listViews.vs.boardColumns')}</span>
      <select className="lv-select lv-vs__group" value={groupBy} aria-label={t('listViews.vs.boardColumnsBy')} onChange={(e) => onChange(e.target.value)}>
        <option value="">{t('listViews.vs.defaultGroup', { field: label(groupByFor(rt)) })}</option>
        <option value="status">{label('status')}</option>
        {choices.map((f) => <option key={f.key} value={f.key}>{label(f.key)}</option>)}
      </select>
    </div>
  );
}
